import classNames from "classnames";
import { ReactNode, RefObject } from "react";
import { Tag } from "~/models/list";

interface BaseTagProps {
  tag?: Tag;
  className?: string;
  trailingContent?: ReactNode;
  linkRef?: RefObject<HTMLAnchorElement>;
}

export function BaseTag(props: BaseTagProps) {
  if (!props.tag?.name) {
    // preserve spacing even if there is no size tag
    return (
      <div
        className={classNames(
          "tw:inline-flex tw:items-center tw:font-sofia-pro tw:font-semibold tw:text-sm tw:lg:text-base tw:tracking-normal tw:text-left tw:transition-colors tw:hover:!bg-gray-50 tw:rounded-lg tw:py-2 tw:px-2.5 tw:mr-2 tw:mb-2",
          props.className,
        )}
      >
        &nbsp;
      </div>
    );
  }

  return (
    <div
      className={classNames(
        "tw:inline-flex tw:items-center tw:max-w-full tw:font-sofia-pro tw:font-semibold tw:text-sm tw:lg:text-base",
        "tw:tracking-normal tw:text-left tw:transition-colors tw:text-gray-800 tw:!bg-gray-50 tw:hover:!bg-gray-50",
        "tw:rounded-lg tw:py-2 tw:px-2.5 tw:mr-2 tw:mb-2 tw:gap-1",
        props.className,
      )}
    >
      <a
        ref={props.linkRef}
        href={props.tag.url}
        className="tw:min-w-0 tw:flex-1 tw:overflow-hidden tw:text-ellipsis tw:whitespace-nowrap tw:pb-[3px]"
      >
        {props.tag.name}
      </a>

      {props.trailingContent}
    </div>
  );
}
